<template>
  <div class="notice-container">
    <div class="notice-content" @click="handleClick">
      <div class="notice-left">
        <span class="notice-text">公告通知</span>
        <span v-if="noticeCount > 0" class="notice-badge">{{
          noticeCount
        }}</span>
      </div>
      <div class="notice-right">
        <span class="notice-link">查看</span>
        <i class="notice-arrow"><van-icon name="arrow" /></i>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "HomeNotice",
  props: {
    noticeCount: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
  },
  methods: {
    handleClick() {
      this.$emit("goNoticeList");
    },
  },
};
</script>

<style lang="stylus" scoped>
.notice-container {
  background: #fff;
}

.notice-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  cursor: pointer;

  &:active {
    background-color: #f5f5f5;
  }
}

.notice-left {
  display: flex;
  align-items: center;
  position: relative;
}

.notice-text {
  font-size:14px;
  color: #333;
}

.notice-badge {
  background: #009dd9;
  color: #fff;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 10px;
  margin-left: 8px;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.notice-right {
  display: flex;
  align-items: center;
  color: #999;
}

.notice-link {
  font-size: 14px;
  margin-right: 5px;
}

.notice-arrow {
  font-size: 14px;
  font-style: normal;
}
</style>
